import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse, ParkingHistory } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse, RequestDicountPayload } from "../../../models/discount.model";
import { ParkingUserVehicleDto } from "../../../models/ev.model";

@Injectable({
  providedIn: 'root',
})

export class ApiParkingService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
  ) { }

    getParkingCardInfo(
      token: string,
      uid: string,
    ): Observable<ParkingCardInfo[]> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const url = this.tokenUrl + `/Cityparking/GetParkingCardInfo?uid=${uid}`;
      return this.http.get<ParkingCardInfo[]>(url, { headers });
    }

      getParkingHistory(
        token: string,
        uid: string,
        start: Date,
        end: Date,
      ): Observable<ParkingHistory[]> {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
    
        const startStr = start.toISOString();
        const endStr = end.toISOString();
        const url = `${this.tokenUrl}/Cityparking/GetPakringHistory?uid=${uid}&start=${startStr}&end=${endStr}`;
        return this.http.get<ParkingHistory[]>(url, { headers });
      }

        getParkingUser(
          uid: string,
          token: string,
        ): Observable<ParkingUserVehicleDto[]> {
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
          });
          const url = this.tokenUrl + '/Cityparking/GetParkingUser';
          const params = new HttpParams().set('Uid', uid);
      
          console.log('📨 Sent Api Parking user : ', url, headers, params.toString());
          return this.http.get<ParkingUserVehicleDto[]>(url, {
            headers,
            params,
          });
        }

          RequestStamp(
            body: RequestDicountPayload,
            token: string,
          ): Observable<StatusAPIResponse> {
            const headers = new HttpHeaders({
              'Content-Type': 'application/json',
            });
            return this.http.post<StatusAPIResponse>(
              this.tokenUrl + '/Cityparking/RequestDiscountOCR',
              body,
              { headers },
            );
          }
    
}